export const iconsConsideration = {
    'ta-time': 'time',
    'ta-recharge': 'recurrent-payment-currency-dollar',
    'ta-amount': 'bag-of-money-currency-dollar'
};